








import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Helpers
import { parseBase64 } from '@/helpers/image'

// Components
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'

@Component({
  components: { ImageViewerValue }
})
export default class FieldSupport extends Vue {
  image = new Image()
  galleryReady: boolean = false
  fullImageIsLoading: boolean = false

  @Getter('token') token
  @Getter('proovCode', { namespace: 'report' }) proovCode
  @Getter('canShowValues', { namespace: 'report' }) canShowValues
  @Getter('canEditValues', { namespace: 'report' }) canEditValues
  @Getter('canShowDropoffValues', { namespace: 'report' }) canShowDropoffValues
  @Getter('canEditDropoffValues', { namespace: 'report' }) canEditDropoffValues
  @Getter('isFinished', { namespace: 'report' }) isFinished
  @Getter('isWaiting', { namespace: 'report' }) isWaiting
  @Getter('isReturn', { namespace: 'report' }) isReturn
  @Action('updateGallery', { namespace: 'report' }) updateGallery

  @Prop() field
  @Prop() partID
  @Prop({ type: String, default: 'first' }) position: string
  @Prop({ type: Boolean, default: false }) dropoff: boolean
  @Prop({ type: String, default: '' }) state: string

  get fieldLegend() {

    if (this.position === 'first' && !this.field.picturePath && !this.canEditValues) {
      return this.$t('global.field.empty')
    }

    if ((this.position === 'second' && !this.field.dropoffPicturePath && !this.field.picturePath)
      || this.state === 'finished') {
      return this.$t('report.edit.photo.nothing_to_signal')
    }

    return this.$t('report.edit.supports.compare_with_application')
  }

  get currentValue() {
    return this.position === 'first' ? this.field.picturePath : this.field.dropoffPicturePath
  }

  updateImageSrc(src) {
    this.image.onload = () => {
      this.galleryReady = true
    }
    this.image.src = src
  }
}
